import * as React from "react";
const SvgEmpty = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 284.559 284.559", style: {
  enableBackground: "new 0 0 284.559 284.559"
}, xmlSpace: "preserve", ...props });
export default SvgEmpty;
